export const CONFIRM_POPUP_FULL_FILL_TYPE = 'full_filled'; // 점선 꽉 채움 체크
export const CONFIRM_POPUP_QUALITY_TYPE = 'image_quality'; // 이미지 해상도 체크
export const CONFIRM_POPUP_FOLDING_TYPE = 'folding'; // 점선 3mm 이내 평행 체크
export const CONFIRM_POPUP_ANY_CORNER_OUT_BOUNDS = 'out_bounds'; // 제품 전면 영역 이탈 체크
export const CONFIRM_POPUP_ANY_CORNER_OUT_BOUNDS_FULL_FILL_TYPE = 'out_bounds_full_filled'; // 제품 전면 영역 이탈, 점선 꽉 채움 체크 둘 중 하나 체크
export const CONFIRM_POPUP_WRONG_TEXT_TYPE = 'wrong_text';
export const CONFIRM_POPUP_MCON_AGREEMENT = 'mcon_agreement';
/* 조건은 없음, 상시 동의 텍스트 하단에 뜸, */
